<footer>
  <p>Powered by <img src="../../../assets/img/buildflex-logo.png"></p>
  </footer>